import { addBusinessDays, format } from "date-fns";
import { baseUrl } from "../../common/config";
import { http } from "../../common/helpers/index";
import { ApiResponse } from "../../models/api/api-response";

interface MentorSummary {
  expertises: string[];
  achievements: string[];
  profileVideoLink: string;
}

export const getAvailableDates = async (
  start: Date,
  end?: Date
): Promise<string[]> => {
  const url = `${baseUrl}/api/events/working-hours/availabletimeslots?ExcludeCancelled=true`;
  const $1 = format(start, "yyyy-MM-dd");
  const $2 = format(end ?? addBusinessDays(start, 2), "yyyy-MM-dd");
  const { data } = await http.get(`${url}&Start=${$1}&End=${$2}`);
  return data.data;
};

export const getFollowUpActionItems = async ({ ...params }) => {
  const { data } = await http.get(
    `${baseUrl}/api/todos/action-item/all-call-follow-up`,
    {
      params: {
        ...params,
      },
    }
  );
  return data.data;
};

export const setActionItemStatus = async (params) => {
  const { data } = await http.patch(`${baseUrl}/api/todos/action-item`, params);
  return data.data;
};

export const getParticipantPaymentSummary = async () => {
  const { data } = await http.get(`${baseUrl}/api/payment/participant`);
  return data.data;
};

export const getSessionEventProducts = async () => {
  const { data } = await http.get(
    `${baseUrl}/api/payment/membership-product?type=SessionEvent`
  );
  return data.data;
};

export const generateStripeCheckoutLink = async (productId) => {
  const { data } = await http.get(
    `${baseUrl}/api/payment/checkout/${productId}`
  );
  return data.data;
};

export const getMentorSummary = async (nonParticipantProfileId) => {
  const { data } = await http.get<ApiResponse<MentorSummary>>(
    `${baseUrl}/api/non-participant/${nonParticipantProfileId}`
  );
  return data.data;
};
